import { render, staticRenderFns } from "./picker.vue?vue&type=template&id=38108758&scoped=true"
import script from "./picker.vue?vue&type=script&lang=js"
export * from "./picker.vue?vue&type=script&lang=js"
import style0 from "./picker.vue?vue&type=style&index=0&id=38108758&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38108758",
  null
  
)

export default component.exports